import { Grid } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Back from "../components/Back";
import CardInbox from "../components/CardInbox";
import LoadingPage from "../components/LoadingPage";
import Menu from "../components/Menu";
import Unauthorized from "../components/Unauthorized";
import { baseService } from "../helpers/baseService";
import { config } from "../helpers/config";
import { setTitle } from "../helpers/title";
import { useAuth } from "../helpers/useAuth";

export default function Inbox() {
  const { auth } = useAuth();
  const [loadingPage, setLoadingPage] = useState(false);
  const [inbox, setInbox] = useState([]);

  useEffect(() => {
    setTitle("Inbox");
    setLoadingPage(true);
    baseService.get(
      config.services.event.getInbox,
      (res) => {
        setInbox(res.data);
      },
      (err) => {
        console.log(err);
      }
    );
    setLoadingPage(false);
  }, []);

  return (
    <div>
      <div className="container" />
      {auth && <Back title="Inbox" />}
      <div className="content">
        {auth ? (
          loadingPage && inbox.length === 0 ? (
            <LoadingPage />
          ) : inbox.length > 0 ? (
            inbox.map((value) => {
              return <CardInbox data={value} key={value._id} />;
            })
          ) : (
            <Grid placeItems="center" minHeight="var(--page-height)">
              tidak ada data
            </Grid>
          )
        ) : (
          <Unauthorized />
        )}
      </div>
      <Menu />
    </div>
  );
}
